import { Component, OnInit, EventEmitter, Output, Directive, HostListener, ElementRef, Input } from '@angular/core'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'
import { Subject } from 'rxjs'

@Directive({
    selector: '[uiConfirm]',
})
export class ConfirmActionDirective {
    @Input()
    confirmMessage = 'Do you confirm?'
    @Input()
    confirmTitle = 'Confirmation'
    @Input()
    confirmLabel = 'Yes'
    @Input()
    cancelLabel = 'No'
    @Output() confirm = new EventEmitter<any>()
    @Output() cancel = new EventEmitter<any>()

    @Input()
    skipConfirm = false

    constructor(private el: ElementRef, private modalService: BsModalService) {}

    @HostListener('click', ['$event'])
    onClick(event: Event) {
        event && event.stopPropagation()
        if (this.skipConfirm) {
            this.confirm.emit(true)
            return
        }
        console.log('Confirm click')
        const modal = this.modalService.show(ConfirmDialogModal, {
            initialState: {
                message: this.confirmMessage,
                confirmLabel: this.confirmLabel,
                cancelLabel: this.cancelLabel,
                confirmTitle: this.confirmTitle,
            },
        })

        modal.content.result.subscribe(result => {
            if (result) {
                this.confirm.emit(result)
            } else {
                this.cancel.emit()
            }
        })
    }
}

@Component({
    template: `
        <div class="modal-body text-center">
            <h3>{{ confirmTitle }}</h3>
            <p pb-3 pt-3>{{ message }}</p>
            <button type="button" class="btn btn-primary mr-3" (click)="confirm()">{{ confirmLabel }}</button>
            <button type="button" class="btn btn-ghost-secondary" (click)="decline()">{{ cancelLabel }}</button>
        </div>
    `,
})
class ConfirmDialogModal {
    @Input()
    message: string
    @Input()
    cancelLabel: string
    @Input()
    confirmLabel: string
    @Input()
    confirmTitle: string
    result: Subject<boolean> = new Subject<boolean>()

    constructor(public modalRef: BsModalRef) {}

    confirm(): void {
        this.result.next(true)
        this.modalRef.hide()
    }

    decline(): void {
        this.result.next(false)
        this.modalRef.hide()
    }
}
